import AuthMiddleware from "@/router/middleware/AuthMiddleware";
import { RouteRecordRaw } from "vue-router";
import AdminAuthMiddleware from "@/router/middleware/AdminAuthMiddleware";

const adminRoutings: Array<RouteRecordRaw> = [
	{
		name: "admin-pass-through",
		path: "/admin",
		component: () => import("@/views/admin/AdminPassThrough.vue"),
		meta: { middleware: [new AuthMiddleware(), new AdminAuthMiddleware()] },
		children: [
			{
				name: "admin",
				path: "/admin",
				component: () => import("@/views/admin/AdminPage.vue"),
			},
			/*----- users -----*/
			{
				name: "admin-users",
				path: "/admin/users",
				component: () => import("@/views/admin/users/UsersPage.vue"),
			},
			{
				name: "admin-user-detail",
				path: "/admin/users/:id",
				component: () => import("@/views/admin/users/UserDetailPage.vue"),
			},
			{
				name: "admin-user-reset-password",
				path: "/admin/users/:id/resetPassword",
				component: () => import("@/views/admin/users/ResetPassword.vue"),
			},
			/*----- roles -----*/
			{
				name: "admin-roles",
				path: "/admin/roles",
				component: () => import("@/views/admin/roles/RolesPage.vue"),
			},
			{
				name: "admin-roles-add",
				path: "/admin/roles/add",
				component: () => import("@/views/admin/roles/AddRolePage.vue"),
			},
			{
				name: "admin-role-detail",
				path: "/admin/roles/:id",
				component: () => import("@/views/admin/roles/RoleDetailPage.vue"),
			},
			/*----- divisions -----*/
			{
				name: "admin-divisions",
				path: "/admin/divisions",
				component: () => import("@/views/admin/divisions/DivisionsPage.vue"),
			},
			{
				name: "admin-division-detail",
				path: "/admin/divisions/:id",
				component: () => import("@/views/admin/divisions/DivisionDetailPage.vue"),
			},
			{
				name: "admin-divisions-add",
				path: "/admin/divisions/add",
				component: () => import("@/views/admin/divisions/AddDivisionPage.vue"),
			},
			{
				name: "admin-settings",
				path: "/admin/settings",
				component: () => import("@/views/SettingsPage.vue"),
			},
		],
	},
];

export default adminRoutings;
